import { render, staticRenderFns } from "./CapitecPayBankForm.vue?vue&type=template&id=0cbf76d4&scoped=true"
import script from "./CapitecPayBankForm.vue?vue&type=script&lang=js"
export * from "./CapitecPayBankForm.vue?vue&type=script&lang=js"
import style0 from "./CapitecPayBankForm.vue?vue&type=style&index=0&id=0cbf76d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbf76d4",
  null
  
)

export default component.exports